import { render } from "./PropertyView.vue?vue&type=template&id=ea05b740&scoped=true"
import script from "./PropertyView.vue?vue&type=script&lang=js"
export * from "./PropertyView.vue?vue&type=script&lang=js"

import "./PropertyView.vue?vue&type=style&index=0&id=ea05b740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea05b740"]])

export default __exports__